import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.12em] -mb-[0.12em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ index, label, children }) => (
  <section className="relative">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal y={16}>
        <div data-testid={`chapter-${index}`} className="flex items-center gap-4 pt-10 sm:pt-14">
          <span className="font-mono-label text-xs font-bold text-cyan-600">{index}</span>
          <span className="h-px flex-1 bg-slate-200" />
          <span className="font-mono-label text-[10px] font-bold uppercase tracking-[0.25em] text-slate-400">{label}</span>
        </div>
      </Reveal>
    </div>
    {children}
  </section>
);
